import IblockElement from "./components/IblockElement.vue";

BX.namespace("BX.Citrus.Vue.Component");

BX.Citrus.Vue.Component.IblockElement = function (props) {
	new CitrusUi.Vue({
		name: "IblockElement",
		render: h => h(IblockElement, {
			props: props
		}),
	}).$mount("#" + (props && props.hasOwnProperty('templateId') ? props.templateId : "app"));
}
